
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"15","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.066.566l-9.783 9.782L0 6.066.566 5.5l3.717 3.717L13.5 0l.566.566z","fill":"#fff"}})])
      }
    
      }
    